import { MESES_ABREV, normalizeMesReferencia } from './mesReferencia.ts';

// Filtro de mês da tela de faturas, gravado por usuário. Um mês antigo deixado
// fixado ali reaparece em toda abertura e a lista parece ter "sumido" (Ítalo,
// set/2026, preso em AGO/2025). Ao abrir, uma seleção sem o mês atual nem o
// anterior volta para o mês atual. Escolher mês antigo na tela continua livre.

const indiceMes = (m: string): number | null => {
  const [abrev, ano] = m.split('/');
  const i = MESES_ABREV.indexOf(abrev);
  const a = Number(ano);
  if (i < 0 || !Number.isFinite(a)) return null;
  return a * 12 + i;
};

export const mesAtualReferencia = (hoje: Date): string =>
  `${MESES_ABREV[hoje.getMonth()]}/${hoje.getFullYear()}`;

export interface FiltroMesRevisado {
  meses: string[];
  /** Seleção antiga descartada; vazio quando nada mudou. */
  descartados: string[];
}

export function revisarMesesSalvos(salvos: unknown, hoje: Date): FiltroMesRevisado {
  if (!Array.isArray(salvos)) return { meses: [], descartados: [] };
  const meses = Array.from(new Set(salvos.map(m => normalizeMesReferencia(m)).filter(Boolean)));
  // "Todos" (lista vazia) não esconde nada
  if (meses.length === 0) return { meses, descartados: [] };
  const atual = hoje.getFullYear() * 12 + hoje.getMonth();
  const recente = meses.some(m => {
    const i = indiceMes(m);
    return i !== null && i >= atual - 1;
  });
  if (recente) return { meses, descartados: [] };
  return { meses: [mesAtualReferencia(hoje)], descartados: meses };
}
